import PropTypes from "prop-types";
import React from "react";

import Button from "Components/Button.js";
import Container from "Components/Container.js";
import String from "Components/String.js";
import UiView from "Ui/UiView.js";

/**
 * Ui 404 view
 *
 * @package HOPS
 * @subpackage Ui
 * @copyright Heritage Operations Processing Limited
 */
const Ui404View = ({e404Label, e404Uri}) => {

	return (
		<UiView gap={2}>
			<Container gap={2} justifyItems="center">
				<String
					bold={true}
					str="Page Not Found"
					variant="h5" />
				<String
					str="The link you've visited is invalid."
					variant="h6" />
			</Container>
			<Button
				label={e404Label}
				size="large"
				uri={e404Uri}
				variant="outlined" />
		</UiView>
	);

};

Ui404View.defaultProps = {
	e404Label: "Home",
	e404Uri: "/"
};

Ui404View.propTypes = {
	e404Label: PropTypes.string,
	e404Uri: PropTypes.string
};

export default Ui404View;
